module.exports = __webpack_public_path__ + "static/msp@2x-9c2f1bb41bb83def74b9cb4dc40c3ca5.png";